import { PageTable } from '@components-common/layouts';
import { layoutWorkspace } from '../../_common/layout.workspace';
import { ConfigSection } from '../../../components-fabric';
import { MaterialForm } from '../../../components-domain/bim-domain';
import { materialEntity } from './materials.entity';
import { PageFormToolbar } from '../../../components-common/layout/views/PageFormToolbar';
import { compDBAdditionalCheck } from '../../../components-domain/bim-domain/defaults';

export const materialsSection: ConfigSection = {
  id: 'materials',
  path: 'materials',
  title: 'Materials',
  layout: layoutWorkspace,
  screens: [
    {
      id: 'index',
      path: '.',
      roles: ['STUDY_DIRECTOR', 'LECTURER', 'STUDENT'],
      Component: PageTable,
      tmp: 'index',
      columns: ['name', 'description', { id: 'sourceType' }, 'class'],
      source: '/buildingsms/materials',
      actions: [
        {
          id: 'edit',
          actionToDispatch: { payload: { path: '' } },
          displayTooltip: true,
          tooltipText: 'Edit material',
          additionalChecks: compDBAdditionalCheck,
        } as any,
        {
          id: 'copy',
          roles: ['STUDY_DIRECTOR', 'LECTURER', 'STUDENT'],
          actionToDispatch: {
            payload: {
              copy: '/buildingsms/materials/cloneMaterial',
            },
          },
          displayTooltip: true,
          tooltipText: 'Duplicate material',
        } as any,
        {
          id: 'delete',
          actionToDispatch: {
            payload: {
              endpointToDelete: '/buildingsms/materials',
            },
          },
          additionalChecks: compDBAdditionalCheck,
          displayTooltip: true,
          tooltipText: 'Delete material',
        },
      ],
    } as any,
    {
      id: 'create',
      title: 'Create Material',
      path: 'new',
      roles: ['STUDY_DIRECTOR', 'LECTURER'],
      left: ['create'],
      Component: PageFormToolbar,
      tmp: 'create',
      form: MaterialForm,
      empty: materialEntity.empty,
      schema: materialEntity.schema,
    } as any,
    {
      id: 'edit',
      title: 'Edit Material',
      path: ':materialId',
      idPropSource: 'materialId',
      roles: ['STUDY_DIRECTOR', 'LECTURER'],
      left: ['save'],
      right: ['back'],
      Component: PageFormToolbar,
      tmp: 'edit',
      editSource: '/buildingsms/materials/',
      form: MaterialForm,
      empty: materialEntity.empty,
      schema: materialEntity.schema,
      endpoints: '/buildingsms/materials/',
    } as any,
  ],
};
